module.exports = __webpack_public_path__ + "static/media/greenTick.671d9552.svg";